const axios = require("axios").default;
const https = require("https");

const axiosInstance = axios.create({
  //5 sec timeout
  timeout: 5000,
  httpsAgent: new https.Agent({ keepAlive: false }),
  //follow up to 10 HTTP 3xx redirects
  maxRedirects: 10,
  //cap the maximum content length we'll accept to 50MBs, just in case
  maxContentLength: 50 * 1000 * 1000,
});

const causeApi = 'cause';
const publicApi = 'public';
let apiMode = causeApi;

function SetPublicMode() {
  apiMode = publicApi;
}

function SetCauseMode() {
  apiMode = causeApi;
}
function GetMode() {
  return apiMode;
}



const authType = {
  DISABLED: -1,
  CLIENT: 0,
  USER: 1
}

const AuthStatus = {
  MISSING: 0,
  VALID: 1,
  NEEDS_REFRESH: 2,
  NEW_AUTH: 3,
  FAILED_AUTH: -1,
  ERASED_AUTH:4
}

let authMode = authType.CLIENT;

function DisableAuth() {
  authMode = authType.DISABLED;
}
function UseClientAuth() {
  authMode = authType.CLIENT;
}
function UseUserAuth(useDevOAuth = false) {

  authMode = authType.USER;
  tokenUrl = useDevOAuth ? devTokenUrl : prodTokenUrl;
}

function GetAuthMode() {
  return authMode
}
function GetAuthModeAsString() {
  return Object.keys(authType).find(k => authMode == authType[k]);
}

function GetAuthStatus() {
  if (!authData) return AuthStatus.MISSING;
  if (v5TokenExpiration <= Date.now()) return AuthStatus.NEEDS_REFRESH;
  return AuthStatus.VALID;
}

let authCallback = () => { }
/**
 * Sets the auth callback to use for Auth Updates. Calling this multiple time will replace the current callback.
 * @param {Function} callback 
 */
function RegisterAuthCallback(callback) {
  authCallback = callback;
}
/**
 * Removes the current callback from Auth Updates
 */
function UnregisterAuthCallback() {
  authCallback = () => { }
}

/**
 * For usage with a tiltify proxy, disables AuthToken and overrides V5 URL.
 * @param {string} url The base URL to use instead of tiltify
 */
function UseProxy(baseURL = 'https://12v5i9usl3.execute-api.us-east-1.amazonaws.com/api/') {
  if (authMode != authType.USER)
    DisableAuth();
  OverrideBaseV5URL(baseURL);
}

/**
 * Just waits asynchronously for the given time. Useful for Tiltify timeouts
 * @param {number} seconds
 * @returns
 */
function WaitForSeconds(seconds) {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, seconds * 1000);
  });
}

const request = (endpoint, method = "get") => {
  let config = {
    method: method,
    url: `https://tiltify.com/api/v3/${endpoint}`,

    headers: {
      Authorization: "Bearer " + process.env.TILTIFY_ACCESS_TOKEN,
    },
  };
  return axiosInstance(config);
};

let v5Token = null;
let v5TokenExpiration = 0;
//
let v5RefreshToken = null;
const devTokenUrl = `https://qo76bga8l7.execute-api.us-east-1.amazonaws.com/api/tiltify/token/`;
const prodTokenUrl = `https://gr3holprdf.execute-api.us-east-1.amazonaws.com/api/tiltify/token/`
let tokenUrl;
let refreshUrl = null;

let authData = null;
function currentAuthData() { return authData; }



/**
 * 
 * @param {string} token 
 * @param {number} expiration Date() compatible milliseconds 
 * @param {string} refresh 
 */
function OverrideAuthToken(token, expiration, refresh = null) {
  v5Token = token;
  v5TokenExpiration = expiration;
  v5RefreshToken = refresh;
}
/**
 * Sets up tiltify-lib's auth tokens from the JSON response from a tiltify auth request
 * Pass in null to erase auth data instead
 * @param {{access_token:string,created_at:string,expires_in:number,refresh_token:string}} data 
 */
function SetAuthData(data) {
  authData = data;
  if (!data) {
    v5Token = null;
    v5TokenExpiration = 0;
    v5RefreshToken = null;
    authCallback({status:AuthStatus.ERASED_AUTH})
    return;
  }
  v5Token = "Bearer " + data.access_token;
  v5TokenExpiration = Date.parse(data.created_at) + (1000 * data.expires_in);
  if (data.refresh_token) v5RefreshToken = data.refresh_token;
  authCallback({status:AuthStatus.NEW_AUTH,authData:data})
}



function CheckClientIDSecret() {
  let errMsg = "";
  if (
    !process.env.hasOwnProperty("TILTIFY_CLIENT_ID") ||
    process.env.TILTIFY_CLIENT_ID.length == 0
  ) {
    errMsg += "process.env.TILTIFY_CLIENT_ID is missing! ";
  }
  if (
    !process.env.hasOwnProperty("TILTIFY_SECRET") ||
    process.env.TILTIFY_SECRET.length == 0
  ) {
    errMsg += "process.env.TILTIFY_SECRET is missing!";
  }
  if (errMsg.length > 0) throw new Error("GetAuthV5Token::" + errMsg);
}




/**
 * 
 * Requests a user access token for the given OAuth code. Switches tiltify-lib to user auth and public api mode
 * @param {string} code The code returned from the Tiltify OAuth system
 * @param {string} redirect_uri The redirect_uri you passed to the Tiltify OAuth system. Do not encode!
 * @param {boolean} [setUserMode=true] Whether to automatically call SetAuthData(...),SetPublicMode(),UseUserAuth(). Defaults to true.
 * @param {boolean} [useDevOAuth=false] use the dev oauth server instead of prod, defaults to false
 * @returns {Promise<{access_token:string,created_at:string,expires_in:number,refresh_token:string}>}
 */
async function GetUserAccessToken(code, redirect_uri, setUserMode = true, useDevOAuth = false) {
  const config = {
    method: "post",
    url: useDevOAuth ? devTokenUrl : prodTokenUrl,
    data: {
      grant_type: "authorization_code",
      redirect_uri,
      code
    }
  }
  try {
    const resp = await axiosInstance(config);
    if (resp.data.error) {
      throw new Error(`${resp.data.error} - ${resp.data.error_description}`);
    }
    if (setUserMode) {
      SetAuthData(resp.data);
      SetPublicMode();
      UseUserAuth(useDevOAuth);
      UseProxy();
    }
    return resp.data;
  } catch (e) {
    console.error("tiltify::GetUserAccessToken:", e.message);
    authCallback({status:AuthStatus.FAILED_AUTH,authData:e.message})
    throw e;
  }
}

/**
 * Helper method that calls SetAuthData, SetPublicMode, UseUserAuth, UseProxy
 * @param {{access_token:string,created_at:string,expires_in:number,refresh_token:string}} authData 
 * @param {boolean} [useDevOAuth=false] use the dev oauth server instead of prod, defaults to false
 */
function LoadUserAccessToken(authData, useDevOAuth = false) {
  SetAuthData(authData);
  SetPublicMode();
  UseUserAuth(useDevOAuth);
  UseProxy();
}

/**
 * 
 * @returns {Promise<string>}
 */
async function GetAuthV5Token() {
  if (authMode == authType.DISABLED) return null; //for use with lambda proxy,
  if (Date.now() > v5TokenExpiration) {
    let config;
    if (authMode == authType.CLIENT) {
      CheckClientIDSecret();
      //console.log("GetAuthV5Token::Token expired at",new Date(v5TokenExpiration).toLocaleString(),". Fetching new one...");
      config = {
        method: "post",
        url: 'https://v5api.tiltify.com/oauth/token',
        data: {
          client_id: process.env.TILTIFY_CLIENT_ID,
          client_secret: process.env.TILTIFY_SECRET,
          grant_type: "client_credentials",
          scope: "cause"
        }
      }
    } else {
      config = {
        method: "post",
        url: tokenUrl,
        data: {
          grant_type: "refresh_token",
          refresh_token: v5RefreshToken
        }
      }
    }
    try {
      const resp = await axiosInstance(config);
      if (resp.data.error) {
        authCallback({ status: AuthStatus.FAILED_AUTH, authData: resp.data.error });
        SetAuthData(null);
        throw new Error(`${resp.data.error} : ${resp.data.error_description}`)
      } else {
        SetAuthData(resp.data);
      }
    } catch (e) {
      console.error("tiltify::GetAuthV5:", e.message);
      throw e;
    }
  }

  return v5Token;
}

function GetTokenExpiration() {
  return v5TokenExpiration;
}

let baseV5URL = 'https://v5api.tiltify.com/api/'
function OverrideBaseV5URL(url) {
  baseV5URL = url;
}
/**
 * Generic request to `https://v5api.tiltify.com/api/${endpoint}`
 * Will auto-retry 5 times on timeout or auth-fail
 * @param {string} endpoint
 * @param {string} method
 * @param {number} retry
 * @returns {Promise<AxiosResponse>}
 */
async function requestV5(endpoint, method = "get", retry = 5) {
  const token = await GetAuthV5Token();

  let config = {
    method: method,
    url: `${baseV5URL}${endpoint}`,
    headers: {
      Authorization: token,
    }
  };

  try {
    const response = await axiosInstance(config);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      if (retry > 0) {
        //if we lost auth, just retry which will get a fresh token
        //if we timeout, or bad gateway, just keep retrying
        if (
          error.response.status == 401 ||
          error.response.code === "ECONNABORTED" ||
          error.response.status == 502
        ) {
          //if we timed out, wait half a second and then retry
          //console.log("Key expired or timed out. Retrying...");
          await WaitForSeconds(0.5);
          return await requestV5(endpoint, method, retry - 1);
        }
      } else console.error("Request V5:: Retried 5 times!");
      //console.error(error);
    }
    throw error; //not our problem
  }
}

async function GET(endpoint) {
  let res;
  try {
    res = (await request(endpoint)).data;
  } catch (err) {
    //console.log(err.response);
    if (err.response && err.response.data) {
      res = err.response.data;
    } else throw err;
  }
  //console.log("GET::", res);

  if (res.meta.status !== 200)
    throw new Error(
      `${res.meta.status}: ${endpoint} : ${res.error.title} : ${res.error.detail}`
    );
  return res.data;
}
/**
 * Helper method for calling the V5 API. Tiltify error responses will be returned as data.
 * @param {string} endpoint `https://v5api.tiltify.com/api/${endpoint}`
 * @param {*} limit Appends '&limit=limit'
 * @param {*} cursor Appends '&after=cursor'. If this is null, will not append anything as Tiltify throws an internal error
 * @returns {Promise<{data:*,metadata:Metadata}|{error:TiltifyError}>}
 */
async function GETV5(endpoint, limit = 100, cursor = null) {
  let res;

  const url =
    `${endpoint}${endpoint.includes("?") ? "&" : "?"}limit=${limit}` +
    (cursor != null ? `&after=${cursor}` : "");

  try {
    res = (await requestV5(url)).data;
  } catch (err) {
    if (err.response && err.response.data) {
      res = err.response.data;
    } else throw err;
  }

  return res;
}

/**
 * Callback used by GETV5_Paginator.
 * @callback dataCallback
 * @param {any[]} data
 * @param {Metadata} metadata
 * @returns {Promise<string>} 
 */

/**
 * A DIY paginator. You provide a async callback, that will receive an array of data per page. Your callback must return a cursor to continue, or null to stop.
 * @param {string} endpoint 
 * @param {dataCallback} dataCallback callback
 * @param {number} limit The amount of entries to grab at a time, defaults to 100.  Max value is 100. 
 */
async function GETV5_Paginator(endpoint, dataCallback, limit = 100) {
  let cursor = null;
  let shouldContinue = false;
  do {
    const resp = await GETV5(endpoint, Math.min(limit, 100), cursor);
    if (resp.error) throw new Error(JSON.stringify(resp.error) + endpoint + Math.min(limit, 100).toString() + cursor);
    try {
      cursor = await dataCallback(resp.data, resp.metadata);
    } catch (err) {
      console.error('GETV5_Paginator::', endpoint, err);
    }
  } while (cursor !== null);
}

/**
 *
 * A wrapper around GETV5 that handles paginating results via cursor.
 * @param {string} endpoint
 * @param {number} [max=Number.MAX_VALUE] The max size of the array returned.
 * @param {number} [batchLimit=100] The limit size to use when making requests. Generally you dont need to change this
 * @returns
 */
async function GETV5_Array(endpoint, max = Number.MAX_VALUE, batchLimit = 100) {
  /*
  TODO: might change this so if there is an error, it returns the partial array and the error object
  Throwing an error right now isn't consistent with the GETV5 logic, which returns the error as a response.
  */
  let cursor = null;
  const data = [];

  do {
    const resp = await GETV5(endpoint, Math.min(batchLimit, max - data.length), cursor);
    if (resp.error) throw new Error(JSON.stringify(resp.error) + endpoint + Math.min(batchLimit, max).toString() + cursor);
    data.push(...resp.data);
    cursor = resp.metadata.after;
  } while (cursor != null && data.length < max);
  return data;
}



/**
 * Gets the Campaign for the id. If supporting is set true, this will return the Supporting Campaign instead (if possible).
 * @param {number} id
 * @param {boolean} isTeam false
 * @param {boolean} supporting false
 * @returns {Promise<Campaign | TeamCampaign}
 */
async function GetCampaign(id, isTeam = false, supporting = false) {
  let res;
  try {
    res = await GETV5(`${apiMode}/${isTeam ? "team_" : ""}campaigns/${id}`);
  } catch (error) {
    console.error(error);
    return null;
  }
  if (
    supporting &&
    res.hasOwnProperty("supportingCampaignId") &&
    res.supportingCampaignId != null
  ) {
    const scid = res.supportingCampaignId;
    try {
      res = await GetCampaign(scid, false);
    } catch (err) {
      console.warn(
        `GetCampaign(${id})::supporting: Found supportingCampaignId ${scid} but got an error:`,
        err
      );
    }
  }
  if (res.error) {
    if (res.error.status == 404) return null;
    throw new Error(JSON.stringify(res.error));
  }
  return res.data;
}

/**
 * Returns the Team data or null
 * @param {string} slug
 * @returns {Promise<Team>}
 */
async function FindTeam(slug) {
  let resp = await GETV5(`public/teams/by/slug/${slug}`);
  if (resp.error) {
    if (resp.error.status == 404) return null;
    throw new Error(JSON.stringify(resp.error));
  }
  return resp.data;
}

/**
 * Returns the User data or null
 * @param {string} slug
 * @returns {Promise<User>}
 */
async function FindUser(slug) {
  let resp = await GETV5(`public/users/by/slug/${slug}`);
  if (resp.error) {
    if (resp.error.status == 404) return null;
    throw new Error(JSON.stringify(resp.error));
  }
  return resp.data;
}
/**
 * Returns the campaign data or null
 * @param {string} userslug
 * @param {string} campaignslug
 * @param {boolean} isTeam false
 * @returns {Promise<Campaign | TeamCampaign>}
 */
async function FindCampaign(userslug, campaignslug, isTeam = false) {
  //public/campaigns/by/slugs/{user_slug}/{campaign_slug}
  //https://tiltify.com/+yarrforthecause/gamingforthekids
  let resp;
  if (isTeam) {
    resp = (await GETV5(`${apiMode}/team_campaigns/by/slugs/${userslug}/${campaignslug}`));
  } else {
    resp = (await GETV5(`${apiMode}/campaigns/by/slugs/${userslug}/${campaignslug}`));
  }

  if (resp.error) {
    if (resp.error.status == 404) return null;
    throw new Error(JSON.stringify(resp.error));
  }
  return resp.data;
}

async function GetTeam(team) {
  return await GET(`teams/${team}`);
}
/**
 * 
 * @param {string} id 
 * @param {boolean} [isTeam=false] 
 * @returns {Promise<Target[]>}
 */
async function GetTargets(id, isTeam = false) {
  return await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/targets`);
}
/**
 * Gets the milestones for a given campaign ID
 * @param {string} id campaign ID
 * @param {boolean} isTeam false
 * @returns {Promise<Milestone[]>}
 */
async function GetMilestones(id, isTeam = false) {
  return await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/milestones`);
}
/**
 * Gets the next milestone for a campaign
 * @param {number} id Campaign ID number
 * @param {boolean} isTeam false
 * @param {number} amountRaised (optional) if not null, use this instead of fetching the campaign
 * @returns {Promise<Milestone>}
 */
async function GetNextMilestone(id, isTeam = false, amountRaised = null) {
  if (amountRaised === null) {
    const c = await GetCampaign(id, isTeam);
    if (c) amountRaised = c.amount_raised.value;
    else {
      console.warn("GetNextMilestone:: couldn't pull campaign for " + id);
      return null;
    }
  }
  //filter out milestones we've already hit, then sort them so the next milestone is index 0
  const milestones = (await GetMilestones(id, isTeam))
    .filter((value) => {
      return value.amount && value.amount.value > amountRaised;
    })
    .sort((a, b) => {
      return a.amount.value - b.amount.value;
    });
  if (milestones.length < 1) return null;
  return milestones[0];
}
/**
 * Gets the polls for a campaign
 * @param {string} id campaign ID
 * @param {boolean} isTeam false
 * @returns {Promise<Poll[]>}
 */
async function GetPolls(id, isTeam = false) {
  return (await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/polls`));
}

/**
 * Gets a single poll for a campaign by ID
 * @param {string} campaignID
 * @param {string} pollID Must by V5 ID!  Legacy ID will return BAD REQUEST
 * @param {boolean} isTeam
 * @returns {Promise<Poll>}
 */
async function GetPoll(campaignID, pollID, isTeam = false) {
  return await GETV5(
    `public/${isTeam ? "team_" : ""}campaigns/${campaignID}/polls/${pollID}`
  );
}

/**
 * Gets the schedule for a given campaign
 * @param {string} id campaign ID
 * @param {boolean} isTeam false
 * @returns {Promise<Schedule[]>}
 */
async function GetSchedule(id, isTeam = false) {
  return await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/schedules`);
}
/**
 * Gets the rewards for a given campaign
 * @param {string} id
 * @param {boolean} isTeam false
 * @returns {Promise<Reward[]>}
 */
async function GetRewards(id, isTeam = false) {
  return (await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/rewards`));
}

/**
 * 
 * @param {string} id campaign ID
 * @param {boolean} isTeam false
 * @param {number} [count=10] The number of donations to get. Defaults to 10. Use Number.MAX_VALUE to get everything. 
 * @param {string} [completed_before=null] timestamp in  ISO8601 format
 * @param {string} [completed_after=null] timestamp in  ISO8601 format
 * @returns {Promise<Donation[]>}
 */
async function GetCampaignDonations(id, isTeam = false, count = 10, completed_before = null, completed_after = null) {
  //?count=
  let completed = []
  if (completed_before) {
    completed.push(`completed_before=${completed_before}`);
  }
  if (completed_after) {
    completed.push(`completed_after=${completed_after}`);
  }
  //convert the array into a string
  if (completed.length > 0) {
    completed = "?" + completed.join('&');
  } else {
    completed = '';
  }

  return await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/donations${completed}`, count);
}

/**
 * Gets a Fundraising Event by id
 * @param {string} fundraiserID
 * @returns {Promise<FundraisingEvent>}
 */
async function GetFundraiser(fundraiserID) {
  return (await GETV5(`${apiMode}/fundraising_events/${fundraiserID}`)).data;// (sjFundraiserUrl + fundraiserID + "?&status=published")).totalAmountRaised.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

/**
 * Gets all St. Jude Fundraising Events
 * @returns {Promise<FundraisingEvent[]>}
 */
async function GetCurrentEvents() {
  return (await GETV5(`public/causes/400f5687-6017-4d1a-a4d9-7c9166b984c2/fundraising_events?limit=100`));
}

/**
 * Get's the campaign for the team. If campaign is null, then all campaigns will be returned
 * @param {number | string} team Either the ID or the slug
 * @param {number | string | null} campaign Either the ID or the slug
 */
async function GetTeamCampaign(team, campaign = null) {
  if (campaign === null) return await GET(`teams/${team}/campaigns`);
  return await GET(`teams/${team}/campaigns/${campaign}`);
}

async function GetAllTeamCampaigns() {
  ///api/cause/team_campaigns
  let after = '';
  let campaigns = [];
  let resp;

  do {
    resp = (await requestV5(`${apiMode}/team_campaigns?limit=100${after}`)).data;
    campaigns = campaigns.concat(resp.data);
    //shouldContinue = resp.data.length == 100 && resp.metadata.after != null;
    after = "&after=" + resp.metadata.after;
  } while (resp.data.length == 100 && resp.metadata.after != null);
  return campaigns;
}
/**
 * Get's all campaigns for a User ID
 * @param {string} id
 * @returns {Promise<Campaign[]>}
 */
async function GetUserCampaigns(id) {
  let resp;
  resp = await GETV5_Array(`public/users/${id}/campaigns`);
  return resp;
}
/**
 * Gets all campaigns for a Team ID
 * @param {string} id
 * @returns {Promise<TeamCampaign[]}
 */
async function GetTeamCampaigns(id) {
  return await GETV5_Array(`public/teams/${id}/team_campaigns`);
}

/**
 * Returns a cause by its ID
 * @param {string} id 
 * @returns {Promise<Cause>}
 */
async function GetCause(id) {
  const resp = await GETV5(`public/causes/${id}`);
  if (resp.error) {
    if (resp.error.status == 404) return null;
    throw new Error(JSON.stringify(resp.error));
  }
  return resp.data;
}

/**
 *
 * Gets the donor leaderboard for a given campaign ID
 * @param {string} id event ID
 * @param {"daily" | "weekly"|"monthly"|"yearly"|"ytd"|"all"} time_type 
 * @param {boolean} isTeam false
 * @param {Number} max The number of leaderboard entries you want. 
 * @returns {Promise<Donor[]>}
 */
async function GetLeaderboard(id, time_type, isTeam = false, max = Number.MAX_VALUE) {
  if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(time_type)) {
    throw new Error(`tiltify-lib::GetLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`)
  }
  return await GETV5_Array(`${apiMode}/${isTeam ? 'team_' : ''}campaigns/${id}/donor_leaderboard?time_type=${time_type}`, max);
}

/**
 * Gets the user_leaderboards for a Team Campaign.
 * @param {string} id team ID
 * @param {"daily" | "weekly"|"monthly"|"yearly"|"ytd"|"all"} time_type 
 * @param {Number} [max=Number.MAX_VALUE]  Defaults to MAX_VALUE which will return everything
 * @returns {Promise<User>}
 */
async function GetTeamUserLeaderboard(id, time_type, max = Number.MAX_VALUE) {
  if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(time_type)) {
    throw new Error(`tiltify-lib::GetLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`)
  }
  return await GETV5_Array(`public/team_campaigns/${id}/user_leaderboards?time_type=${time_type}`, max);
}

/**
 * Lists the Donor leaderboard for the given cause and time_type
 * @param {Number} cause_id 
 * @param {"daily" | "weekly"|"monthly"|"yearly"|"ytd"|"all"} time_type 
 * @param {Number} [max=Number.MAX_VALUE ]
 * @returns {Promise<Donor[]>}
 */
async function GetCauseDonorLeaderboard(cause_id, time_type, max = Number.MAX_VALUE) {
  if (!["daily", "weekly", "monthly", "yearly", "ytd", "all"].includes(time_type)) {
    throw new Error(`tiltify-lib::GetCauseDonorLeaderboard: Invalid time_type! Must be one of "daily" | "weekly" | "monthly" | "yearly" | "ytd" | "all"`)
  }
  return await GETV5_Array(`public/cause/${cause_id}/donor_leaderboard?time_type=${time_type}`);
}

/**
 * Gets the user_leaderboard for the given fundraising_event id.
 * @param {string} id event ID
 * @param {number} [count=20]  Defaults to 20
 * @returns {Promise<User[]>}
 */
async function GetEventUserLeaderboard(id, count = 20) {
  return await GETV5_Array(
    `${apiMode}/fundraising_events/${id}/user_leaderboard`, count);
}

/**
 * 
 * Returns a user for a given oauth access token
 * ONLY WORKS ON USER AUTH
 * @returns {Promise<User>}
 */
async function GetCurrentUser() {
  if (authMode !== authType.USER) throw new Error("You are not in user auth mode!")
  return await GETV5('public/current-user');
}

/**
 * Gets up to 3 active matching pledges for a given campaign.
 * NOTE: "Status = active" seems to also return inactive campaigns that timed out, because their completed_at field is null
 * @param {string} campaign_id 
 * @returns {Promise<DonationMatch[]>}
 */
async function GetDonationMatches(campaign_id) {
  return await GETV5(`campaigns/${campaign_id}/donation_matches?status=active&limit=100`).data;
}

module.exports = {
  requestV5,
  GETV5,
  GETV5_Array,
  GETV5_Paginator,
  FindCampaign,
  FindTeam,
  FindUser,
  GetAuthV5Token,
  OverrideAuthToken,
  GetCampaign,
  GetCampaignDonations,
  GetPolls,
  GetPoll,
  GetFundraiser,
  GetMilestones,
  GetNextMilestone,
  GetRewards,
  GetSchedule,
  GetTeam,
  GetTargets,
  GetUserCampaigns,
  GetTeamCampaigns,
  GetCause,
  GetLeaderboard,
  SetCauseMode,
  GetMode,
  GetUserAccessToken,
  LoadUserAccessToken,
  SetAuthData,
  OverrideBaseV5URL,
  UseProxy,
  GetTokenExpiration,
  GetTeamUserLeaderboard,
  GetEventUserLeaderboard,
  SetPublicMode,
  UseClientAuth,
  UseUserAuth,
  GetCauseDonorLeaderboard,
  GetCurrentUser,
  GetDonationMatches,
  GetCurrentEvents,
  GetAuthMode,
  GetAuthModeAsString,
  currentAuthData,
  GetAuthStatus,
  RegisterAuthCallback,
  UnregisterAuthCallback,
  AuthStatus
}
// ---------------
// documentation
// ---------------


/**
 
 */

/**
 * @typedef Metadata
 * @property {string} after
 * @property {string} before 
 * @property {number} limit
 * 
 * @typedef TiltifyError
 * @property {[*]} fields
 * @property {string} message 
 * @property {number} status
 * 
 
 * 
 * @typedef Money
 * @property {string} currency ex: "USD"
 * @property {string} value ex: "182.32"
 * 
 * @typedef Image
 * @property {string} alt Short image description used as alternative text
 * @property {number} height
 * @property {string} src 
 * @property {number} width
 * 
 * @typedef Livestream
 * @property {string} channel ex: "twitchchannelhere"
 * @property {string} type ex: "twitch"
 * 
 * @typedef Social
 * @property {string} discord
 * @property {string} facebook
 * @property {string} instagram
 * @property {string} snapchat
 * @property {string} tiktok
 * @property {string} twitch
 * @property {string} twitter 
 * @property {string} website
 * @property {string} youtube
 * 
 * @typedef User
 * @property {Image} avatar
 * @property {string} description
 * @property {string} id
 * @property {number} legacy_id
 * @property {string} slug
 * @property {Social} Social
 * @property {Money} total_amount_raised
 * @property {string} url 
 * @property {string} username
 * 
 *
 * 
  

// So technically, we should be able to use "@extends BaseCampaign" but it doesn't work with intellisense

 * @typedef {Object} BaseCampaign
 * @property {Money} amount_raised
 * @property {Image} avatar
 * @property {string} cause_id
 * @property {string} description
 * @property {string} donate_url
 * @property {string} fundraising_event_id
 * @property {Money} goal
 * @property {boolean} has_schedule
 * @property {string} id 
 * @property {string} inserted_at
 * @property {number} legacy_id
 * @property {Livestream} Livestream
 * @property {string} name
 * @property {Money} originial_goal
 * @property {string} published_at
 * @property {string} retired_at
 * @property {string} slug
 * @property {string} status
 * @property {string} supporting_type
 * @property {Money} total_amount_raised
 * @property {string} updated_at
 * @property {string} url


 * Technically we should just be able to do @ extends BaseCampaign  but Intellisense doesn't support that on typedef apparently?

 * @typedef {Object} Campaign
 * @property {Money} amount_raised
 * @property {Image} avatar
 * @property {string} cause_id
 * @property {string} description
 * @property {string} donate_url
 * @property {string} fundraising_event_id
 * @property {Money} goal
 * @property {boolean} has_schedule
 * @property {string} id 
 * @property {string} inserted_at
 * @property {number} legacy_id
 * @property {Livestream} Livestream
 * @property {string} name
 * @property {Money} originial_goal
 * @property {string} published_at
 * @property {string} retired_at
 * @property {string} slug
 * @property {string} status
 * @property {string} supporting_type
 * @property {Money} total_amount_raised
 * @property {string} updated_at
 * @property {string} url
* @property {User} user
* @property {string} user_id
* 
* @typedef {Object} TeamCampaign
* @property {Money} amount_raised
 * @property {Image} avatar
 * @property {string} cause_id
 * @property {string} description
 * @property {string} donate_url
 * @property {string} fundraising_event_id
 * @property {Money} goal
 * @property {boolean} has_schedule
 * @property {string} id 
 * @property {string} inserted_at
 * @property {number} legacy_id
 * @property {Livestream} Livestream
 * @property {string} name
 * @property {Money} originial_goal
 * @property {string} published_at
 * @property {string} retired_at
 * @property {string} slug
 * @property {string} status
 * @property {string} supporting_type
 * @property {Money} total_amount_raised
 * @property {string} updated_at
 * @property {string} url
* @property {Team} team 
* @property {string} team_id
* 
* 
* @typedef Milestone
* @property {boolean} active
* @property {Money} amount
* @property {string} id
* @property {string} inserted_at
* @property {number} legacy_id
* @property {string} name
* @property {string} updated_at
* 
* @typedef Reward
* @property {boolean} active
* @property {Money} amount
* @property {string} description
* @property {string} ends_at
* @property {Money} fair_market_value
* @property {boolean} highlighted
* @property {string} id 
* @property {Image} image 
* @property {string} inserted_at
* @property {number} legacy_id
* @property {string} name
* @property {number} quantity
* @property {number} quantity_remaining
* @property {string} starts_at
* @property {string} updated_at
* 
* @typedef Target 
* @property {boolean} active 
* @property {Money} amount
* @property {Money} amount_raised 
* @property {string} ends_at
* @property {string} id
* @property {string} inserted_at 
* @property {number} legacy_id
* @property {string} name 
* @property {string} updated_at
* 
* @typedef Donation 
* @property {Money} amount 
* @property {string} campaign_id
* @property {string} completed_after
* @property {string} donor_comment
* @property {string} donor_name
* @property {string} fundraising_event_id
* @property {string} id 
* @property {number} legacy_id
* @property {string} poll_id
* @property {string} poll_option_id
* @property {string} reward_id
* @property {boolean} sustained
* @property {string} target_id
* @property {string} team_event_id
* 
* @typedef Schedule 
* @property {string} description
* @property {string} ends_at
* @property {string} id 
* @property {string} inserted_at
* @property {number} legacy_id 
* @property {string} name 
* @property {string} starts_at 
* @property {string} updated_at 
* 
* @typedef Donor 
* @property {Money} amount 
* @property {Image} avatar
* @property {*} heat this is documented as being there... but no clue what it is
* @property {string} id
* @property {string} name 
* @property {string} url 
* 
* @typedef PollOption 
* @property {Money} amount_raised 
* @property {string} id 
* @property {string} inserted_at
* @property {Number} legacy_id 
* @property {string} name 
* @property {string} updated_at 
* 
* @typedef Poll 
* @property {boolean} active 
* @property {Money} amount_raised 
* @property {string} id 
* @property {string} inserted_at
* @property {number} legacy_id
* @property {string} name 
* @property {PollOption[]} options 
* @property {string} updated_at 
* 
* @typedef DonationMatch 
* @property {boolean} active 
* @property {Money} amount 
* @property {string} completed_at 
* @property {string} donation_id 
* @property {string} ends_at 
* @property {string} id 
* @property {string} inserted_at 
* @property {string} matched_by 
* @property {Money} started_at_amount 
* @property {string} starts_at
* @property {Money} total_amount_raised
* @property {string} updated_at
* 
* @typedef Team 
* @property {Image} avatar 
* @property {string} description 
* @property {string} id 
* @property {number} legacy_id 
* @property {string} name 
* @property {string} slug 
* @property {Social} social 
* @property {Money} total_amount_raised 
* @property {string} url 

 * 

 * 
  *  @typedef Cause  
 * @property {Image} avatar 
 * @property {ContactInfo} contact 
 * @property {string} currency_code 
 * @property {string} description 
 * @property {string} government_id 
 * @property {string} id 
 * @property {string} inserted_at 
 * @property {number} legacy_id
 * @property {string} name 
 * @property {string} short_description 
 * @property {string} slug 
 * @property {Social} social 
 * @property {string} updated_at
 * 
 * @typedef ContactInfo
 * @property {string} address_line1
 * @property {string} address_line2 
 * @property {string} city
 * @property {string} country
 * @property {string} email 
 * @property {string} postal_code 
 * @property {string} region
 * 
 * @typedef FundraisingEvent 
 * @property {Image} avatar 
 * @property {string} cause_id 
 * @property {string} currency_code 
 * @property {string} description 
 * @property {string} donate_url 
 * @property {string} ends_at 
 * @property {Money} goal 
 * @property {string} id 
 * @property {string} inserted_at
 * @property {number} legacy_id
 * @property {string} name 
 * @property {string} published_at
 * @property {string} retired_at
 * @property {Money} total_amount_raised
 * @property {string} updated_at
 * @property {string} url
*/